$('#subscribeModal').on('show.bs.modal', function (e) {

  const corso = $(e.relatedTarget).data('corso');
  const sedi = $(e.relatedTarget).data('sedi').split('-');

  if (corso) {
    $('#subscribeModal .id-corso').text(corso);

    $('#subscribeModal select[name="input-sede"] > option').each(function() {
      if ($.inArray(this.value, sedi) < 0) {
        $('#subscribeModal select[name="input-sede"] option[value="' + this.value + '"]')
          .remove();
      }
    });

    $('#subscribeModal input[name="input-nome-corso"]')
      .val(corso)
      .prop('readonly', 'readonly');
  }

  $('#subscribeModal input[name="input-domicilio"]').change(function () {
    if (this.value == 'Sì') {
      $('.domicilio-group').removeClass('d-block').addClass('d-none');
    } else if (this.value == 'No') {
      $('.domicilio-group').removeClass('d-none').addClass('d-block');
    }
  });

});



// WEBPACK FOOTER //
// ./js/inc/subscribe.js